export default __webpack_public_path__ + "locales/es/ArchiveDialog.json?hash=a3324e208e3a06d4bf680a72e351fadf";